<template>
  <div class="userlist">
    <div style="width: 100%">
      <el-row>
        <el-col :span='4'>
          <el-button type='primary' @click='modalVisible = true; modalType = "add"'><i class="el-icon-plus"></i> 添加用户</el-button>
        </el-col>
        <el-form @submit.native.prevent label-width='100px'>
          <el-col :span="8" :offset='2'>
            <el-form-item label='所属厂商:'  v-if="user_is_pta">
              <el-select v-model="f_unit_id" placeholder='所属厂商' size="mini" @change='currentPage = 1; getUserlist()' filterable>
                <el-option label='全部' value='all'></el-option>
                <el-option v-for="(value, key) in unitlist" :key="key" :label='value' :value='Number(key)'></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset='2'>
            <el-form-item label='关键字检索:'>
              <el-input v-model="cdit" placeholder='用户名或手机号' size='mini' style='width: 80%' @keyup.enter.native='currentPage = 1; getUserlist()' clearable @clear='currentPage = 1; getUserlist()'>
                <el-button slot="append" icon="el-icon-search" @click="currentPage = 1; getUserlist()"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>

    <!-- 用户列表 -->
    <div class="flex-row-between">
      <h3 width='100px'>用户列表</h3>
      <div>当前 {{total > 0 ? (pageStart + 1) : 0}} - {{pageEnd > total ? total : pageEnd}} 项, 共 {{total}} 项</div>
    </div>
    <el-table
      :data='userlist'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
    >
      <el-table-column
        type="index"
        width="100"
        :index='indexMethod'
      />
      <el-table-column prop='phone_no' label='手机号'/>
      <el-table-column prop='name' label='用户名'/>
      <el-table-column label='所属厂商' v-if="user_is_pta">
        <template slot-scope="scope">
          {{unitlist[scope.row.unit_id] ? unitlist[scope.row.unit_id] : '未知'}}
        </template>
      </el-table-column>
      <el-table-column label='是否管理员'>
        <template slot-scope="scope">
          {{scope.row.is_admin ? '是' : '否'}}
        </template>
      </el-table-column>
      <!-- <el-table-column prop='create_dt' label='开通时间' width='200'/>
      <el-table-column prop='boxes_count' label='设备数量'/> -->
      <el-table-column
        label='操作'
        width='180'
      >
        <template slot-scope='scope'>
          <el-button type='primary' size='mini' @click='handleSet(scope.row)'>修改</el-button>
          <el-button @click='handleRemove(scope.row)' slot='reference' type='danger' size='mini'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="flex-row-end" style="margin-top: 16px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        v-if="total > pageSize"
        @current-change="onPageChange"
        :current-page.sync='currentPage'
      >
      </el-pagination>
    </div>
    

    <!-- 模态窗 -->
    <el-dialog
      :title="modalType == 'add' ? '新增用户' : '修改用户'"
      :visible.sync="modalVisible"
      width='600px'
      :before-close="handleClose"
    >
      <el-form @submit.native.prevent ref='user-form' :model="form" label-width='120px' :rules="rules">
        <el-form-item label='用户名' prop='name'>
          <el-input v-model="form.name" placeholder='请输入用户名'/>
        </el-form-item>
        <el-form-item label='手机号' prop='phone_no' v-if="modalType == 'add'">
          <el-input v-model="form.phone_no" placeholder='请输入手机号'/>
        </el-form-item>
        <el-form-item label='所属厂商:'  v-if="user_is_pta && modalType == 'add'" prop='unit_id'>
          <el-select v-model="form.unit_id" placeholder='所属厂商' filterable>
            <el-option v-for="(value, key) in unitlist" :key="key" :label='value' :value='Number(key)'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='是否管理员' prop='is_admin'>
          <el-radio-group v-model="form.is_admin" style="width: 360px">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { post, get } from '@/utils/http'
  import { validatePhone } from '@/utils/util'

  export default {
    data() {
      return {
        userlist: [],
        unitlist: [],
        total: 0,
        pageStart: 0,
        pageEnd: 0,
        currentPage: 1,
        pageSize: 10,
        form: {},
        modalVisible: false,
        modalType: '',
        loading: false,
        rules: {
          name: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          phone_no: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: validatePhone('手机号'), trigger: 'blur' }
          ],
          unit_id: [
            { required: true, message: '请选择所属厂商', trigger: 'blur' }
          ],
          is_admin: [
            { required: true, message: '请选择是否为管理员' }
          ],
        },
        cdit: '',
        f_unit_id: 'all'
      }
    },
    computed: {
      ...mapState(['user_id', 'unit_id', 'user_is_pta'])
    },
    mounted() {
      this.getUserlist()
      this.getUnitlist()
    },
    methods: {
      async getUserlist() {
        this.loading = true
        let data = {
          page_ix: this.currentPage,
          page_size: this.pageSize
        }
        if (!this.user_is_pta) {
          data.unit_id = this.unit_id
        }
        if (this.user_is_pta && this.f_unit_id != 'all' ) {
          data.unit_id = this.f_unit_id
        }
        if (this.cdit) {
          data.cdit = this.cdit
        }
        try {
          const res = await post('/user/Auth/queryUser', data)
          this.loading = false
          if (res && res.rst == 0) {
            this.userlist = res.data.data
            this.total = res.data.total
            this.pageStart = (res.data.current_page - 1) * this.pageSize
            this.pageEnd = this.pageStart + this.pageSize
          }
        } catch(err) {
          this.loading = false
        }
      },
      async getUnitlist() {
        try {
          const res = await get('/index/Unit/getUnits')
          if (res && res.rst == 0) {
            let temp = {}
            res.data.forEach(d => {
              temp[d.id] = d.name
            })
            this.unitlist = temp
            console.log(this.unitlist)
          }
        } catch(err) {
          console.log(err)
        }
      },
      handleSet(user) {
        this.form = { ...user }
        this.modalVisible = true
        this.modalType = 'set'
      },
      async handleOk() {
        this.$refs['user-form'].validate(async (valid) => {
          if (valid) {
            switch (this.modalType) {
              case 'add':
                try {
                  const res1 = await post('/user/Auth/addUser', {
                    ...this.form,
                    no: this.form.phone_no,
                    email: `${this.form.phone_no}@take.cloud`
                  })
                  if (res1 && res1.rst == 0) {
                    this.getUserlist()
                    this.handleClose()
                    break
                  }
                  this.$message.error(res1.msg || '添加失败')
                  break
                } catch(err) {
                  this.$message.error('添加失败')
                  break
                }
              case 'set':
                try {
                  const res2 = await post('/user/Auth/setUser', {
                    id: this.form.id,
                    name: this.form.name,
                    is_admin: this.form.is_admin
                  })
                  if (res2 && res2.rst == 0) {
                    this.getUserlist()
                    this.handleClose()
                    break
                  }
                  this.$message.error(res2.msg || '修改失败')
                  break
                } catch(err) {
                  this.$message.error('修改失败')
                  break
                } 
            }
          } else {
            return false;
          }
        });
      },
      handleRemove(user) {
        this.$confirm('确定要删除用户 ' + user.name + ' 吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const res = await post('/user/Auth/removeUser', {
              id: user.id
            })
            if (res && res.rst == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getUserlist()
            }
          } catch(err) {
            this.$message({
              type: 'info',
              message: '删除失败请重试'
            }); 
          }
        });
      },
      handleClose() {
        this.modalVisible = false
        setTimeout(() => {
          this.modalType = ''
          this.resetForm()
          this.form = {}
        }, 200);
      },
      onPageChange(page) {
        this.currentPage = page
        this.getUserlist()
      },
      resetForm() {
        this.$refs['user-form'].resetFields();
      },
      indexMethod(index) {
        return index + this.pageStart + 1;
      }
    },
    name: 'userlist'
  }
</script>
<style lang="less" scoped>

</style>
